<template>
  <v-navigation-drawer
    :value="value"
    @input="input => $emit('input', input)"
    fixed
    temporary
    right
    width="800"
  >
    <div style="min-height: 100%; overflow-y: hidden; background-color: #f1f3f4;" class="d-flex flex-column">
      <header class="pa-4 white d-flex align-center" style="font-size: 1.3em; height: 64px;">
        <v-btn icon @click="$emit('input', false)" class="mr-2">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <span>Adicionando um novo domínio</span>
        <v-spacer></v-spacer>
        <v-btn color="secondary" depressed style="width: 150px;" @click="save()" :loading="loading">Adicionar</v-btn>
      </header>
      <v-divider></v-divider>
      <div class="d-flex flex-column justify-center align-center flex-grow-1 pa-4" style="overflow-y: auto;">
        <div class="pa-4" style="width: 100%; max-width: 600px;">
          <div>O primeiro passo é ter acesso ao gerenciamento do DNS do domínio próprio/terceiro que quer verificar.</div>
          <div class="mt-5 font-weight-bold">Siga as instruções abaixo para verificar o domínio aqui na Zaper:</div>
          <div class="mt-5">
            1 - Insira aqui na Zaper o domínio principal composto pelo www. Exemplo <span class="font-italic">www.meudominio.com.br</span> ou o subdomínio como por exemplo ”ads”,  ”links”, etc. Exemplo <span class="font-italic">links.meudominio.com.br</span>
          </div>
          <div class="mt-5">
            2 - Esteja com o seu servidor de domínio aberto, crie um registro <strong>CNAME</strong> e aponte para <strong>domain.zprs.in</strong>. Lembre-se de Salvar!
          </div>
          <div class="mt-5">
            3 - Volte na Zaper e clique no botão verificar.
          </div>
          <div class="mt-5">
            4 - Apareceu verificado? <strong>Ótimo! Só vai.</strong> Não apareceu? Apenas aguarde e tente algumas horas depois.
          </div>
          <v-text-field
            class="mt-10"
            label="Digite o seu domínio"
            placeholder="Ex: ads.meunegocio.com"
            v-model="form.name"
            outlined
            hide-details
          ></v-text-field>
          <div v-if="error" class="mt-3 caption red--text font-weight-bold d-flex align-center">
            <v-icon small class="mr-1" color="red">mdi-alert</v-icon>
            <span>{{error}}</span>
          </div>
          <div class="d-flex align-center mt-10 caption">
            <v-icon small class="mr-1">mdi-information</v-icon>
            <span>A verificação do domínio pode demorar até 48h. Veja <a class="font-weight-bold" href="https://youtube.com/playlist?list=PLZE-VAOE63PpqLE6CSUBXo2Hh4_b1k6iV" target="_blank">aqui</a> alguns dos erros mais comuns.</span>
          </div>
        </div>
      </div>
      <zp-modal-upgrade v-model="upgrade" type="domain"></zp-modal-upgrade>
    </div>
  </v-navigation-drawer>
</template>

<script>
import ZpModalUpgrade from '@/components/ModalUpgrade'

export default {
  props: ['value'],
  components: {
    ZpModalUpgrade
  },
  data () {
    return {
      loading: false,
      upgrade: false,
      error: '',
      form: {
        name: ''
      }
    }
  },
  methods: {
    validate () {
      return /^([a-z0-9])(([a-z0-9-]{1,61})?[a-z0-9]{1})?(\.[a-z0-9](([a-z0-9-]{1,61})?[a-z0-9]{1})?)?(\.[a-zA-Z]{2,10})+$/.test(this.form.name)
    },
    async save () {
      if (!this.validate()) {
        this.error = 'Oops! Por favor, insira um domínio válido :)'
        return
      }

      this.loading = true

      try {
        await this.$store.dispatch('domains/store', {
          name: this.form.name.replace(/http.?:\/\//g, '')
        })

        this.form = {
          name: ''
        }

        this.$emit('input', false)
      } catch (e) {
        console.error(e)

        this.upgrade = e.message === 'Você já atingiu o limite de domínios permitidos no seu plano.'

        this.error = e.message
      }

      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>